import { createAction } from 'redux-actions'
import { SELECT_EMBED_SIZE } from './types'

export const selectEmbedSize = createAction(SELECT_EMBED_SIZE)
